var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.statuses, function (status) {
      return _c(
        "div",
        { key: status.topic, staticClass: "my-3" },
        [
          status.connected
            ? _c("v-icon", { attrs: { color: "green" } }, [
                _vm._v("mdi-check-circle"),
              ])
            : _c("v-icon", { attrs: { color: "red" } }, [
                _vm._v("mdi-close-circle"),
              ]),
          _vm._v(" " + _vm._s(status.topic) + " "),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }